import {defineMessages} from "@project/i18n";

export const commissionFieldLabelIds = {
  name: "fields.commission.name",
  percentage: "fields.commission.percentage",
} as const;

export const commissionFieldMessages = defineMessages({
  name: {
    id: "fields.commission.name",
    defaultMessage: "Name",
    description: "Commission field label for commission name",
  },
  percentage: {
    id: "fields.commission.percentage",
    defaultMessage: "Percentage",
    description: "Commission field label for commission percentage",
  },
});
